
<!-- Start Listings Area -->
<section class="listings-area" style="padding-bottom: 60px;">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-12">
                <aside class="listings-widget-area">
                    <section class="widget widget_filters">
                        <h3 class="widget-title">Filters</h3>

                        <ul>
                            <li><button type="button" id="applyCategoryFIlter" (click)="applyCategoryFIlter()">Apply Filter</button></li>
                            <li><button type="button" id="clearCategoryFilters" (click)="clearCategoryFilters()">Clear All Filters</button></li>
                            <!-- <li><button type="button">$$$</button></li>
                            <li><button type="button">$$$$</button></li> --> 
                        </ul>
                    </section>

                    <section class="widget widget_categories">
                        <h3 class="widget-title">Categories</h3>

                        <ul>
                            <li>
                                <input id="categories1" type="checkbox" [(ngModel)]="businessFilters.isCheckRestaurant">
                                <label for="categories1">Restaurant</label>
                            </li>
                            <li>
                                <input id="categories2" type="checkbox" [(ngModel)]="businessFilters.isCheckHomeServices">
                                <label for="categories2">Home Service</label>
                            </li>
                            <li>
                                <input id="categories3" type="checkbox" [(ngModel)]="businessFilters.isCheckAgency">
                                <label for="categories3">Agency</label>
                            </li>
                            <li>
                                <input id="categories4" type="checkbox">
                                <label for="categories4">Fitness</label>
                            </li>
                            <li>
                                <input id="categories5" type="checkbox">
                                <label for="categories5">Shopping</label>
                            </li>
                            <li class="hide">
                                <input id="categories6" type="checkbox">
                                <label for="categories6">Hospital</label>
                            </li>
                            <li class="hide">
                                <input id="categories7" type="checkbox">
                                <label for="categories7">Events</label>
                            </li>
                            <li class="hide">
                                <input id="categories8" type="checkbox">
                                <label for="categories8">Clothing</label>
                            </li>
                            <li class="see-all-btn">
                                <span>See All</span>
                            </li>
                        </ul>
                    </section>

                    <section class="widget widget_features">
                        <h3 class="widget-title">Features</h3>

                        <ul>
                            <li>
                                <input id="features1" type="checkbox">
                                <label for="features1">Restaurant</label>
                            </li>
                            <li>
                                <input id="features2" type="checkbox">
                                <label for="features2">Hotel</label>
                            </li>
                            <li>
                                <input id="features3" type="checkbox">
                                <label for="features3">Beauty & Spa</label>
                            </li>
                            <li>
                                <input id="features4" type="checkbox">
                                <label for="features4">Fitness</label>
                            </li>
                            <li>
                                <input id="features5" type="checkbox">
                                <label for="features5">Shopping</label>
                            </li>
                            <li class="hide">
                                <input id="features6" type="checkbox">
                                <label for="features6">Hospital</label>
                            </li>
                            <li class="hide">
                                <input id="features7" type="checkbox">
                                <label for="features7">Events</label>
                            </li>
                            <li class="hide">
                                <input id="features8" type="checkbox">
                                <label for="features8">Clothing</label>
                            </li>
                            <li class="see-all-btn">
                                <span>See All</span>
                            </li>
                        </ul>
                    </section>

                    <section class="widget widget_distance">
                        <h3 class="widget-title">Distance</h3>

                        <ul>
                            <li>
                                <input id="distance1" type="checkbox">
                                <label for="distance1">Driving (5 mi.)</label>
                            </li>
                            <li>
                                <input id="distance2" type="checkbox">
                                <label for="distance2">Walking (1 mi.)</label>
                            </li>
                            <li>
                                <input id="distance3" type="checkbox">
                                <label for="distance3">Biking (2 mi.)</label>
                            </li>
                            <li>
                                <input id="distance4" type="checkbox">
                                <label for="distance4">Within 4 blocks</label>
                            </li>
                            <li>
                                <input id="distance5" type="checkbox">
                                <label for="distance5">Bicycle (6 mi.)</label>
                            </li>
                            <li class="hide">
                                <input id="distance6" type="checkbox">
                                <label for="distance6">Driving (10 mi.)</label>
                            </li>
                            <li class="hide">
                                <input id="distance7" type="checkbox">
                                <label for="distance7">Walking (11 mi.)</label>
                            </li>
                            <li class="see-all-btn">
                                <span>See All</span>
                            </li>
                        </ul>
                    </section>
                </aside>
            </div>

            <div class="col-lg-8 col-md-12">
                <div class="listings-grid-sorting row align-items-center">
                    <div class="col-lg-5 col-md-6 result-count">
                        <p id="totalCountInList">We found <span class="count">{{this.listCount}}</span> listings available for you</p>
                    </div>

                    <div class="col-lg-7 col-md-6 ordering">
                        <div class="d-flex justify-content-end">
                            <div class="select-box">
                                <label>Sort By:</label>
                                <ngx-select-dropdown (searchChange)="searchChange($event)" name="ordering-select" tabindex="0" [multiple]="false" [(ngModel)]="singleSelect" [config]="config" [options]="options2"></ngx-select-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12" *ngFor="let Content of businessFilteredList | paginate: { itemsPerPage: 4, currentPage: verticalListings }">
                        <div class="single-listings-item">
                            <div class="row m-0">
                                <div class="col-lg-4 col-md-4 p-0">
                                    <div class="listings-image" style="background-image: url({{Content.uploadedFilesName[0]}});">
                                        <img [src]="Content.uploadedFilesName[0]" alt="image">
                                        <a routerLink="" class="bookmark-save"><i class="flaticon-heart"></i></a>
                                        <a routerLink="" class="category"><i class="flaticon-cooking"></i></a>
                                        <a routerLink="" class="link-btn"></a>
                                        <div class="author">
                                            <div class="d-flex align-items-center">
                                                <!-- <img [src]="Content.authorImg" alt="image"> -->
                                                <span>Salman</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-8 col-md-8 p-0">
                                    <div class="listings-content">
                                        <span class="status {{'status-open'}}"><i class="flaticon-save"></i> {{Content.OpenClose}}</span>
                                        <h3><a routerLink="/single-listings" (click)="selectBusiness(Content.BUSINESS_DETAIL_ID)">{{Content.BUSINESS_NAME}}</a></h3>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="rating">
                                                <!-- <i class='{{Star.icon}}' *ngFor="let Star of Content.rating;"></i>
                                                <span class="count">({{Content.ratingCount}})</span> -->
                                                <!-- <i class='bx bxs-star' *ngFor="let Star of Content.rating;"></i> -->
                                                <span class="count">18</span>
                                            </div>
                                            <div class="price">
                                                <!-- {{Content.price}} -->
                                                200

                                            </div>
                                        </div>
                                        <ul class="listings-meta">
                                            <li><a routerLink="/"><i class="flaticon-furniture-and-household"></i> {{Content.BUSINESS_CATEGORY}}</a></li>
                                            <li><i class="flaticon-pin"></i> {{Content.BUSINESS_ADDRESS}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                        <div class="pagination-area text-center">
                            <pagination-controls (pageChange)="verticalListings = $event"></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Listings Area -->
